// @flow

import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type Merchant, type MerchantConfig } from '@tectonics/prs/merchant/types';
import { getMerchantConfig } from '../get-merchant-config';

export function getMerchantConfigValue<K: $Keys<MerchantConfig>>(
  configName: K,
  arg: IncomingPayment | Merchant,
): $ElementType<MerchantConfig, K> | null {
  const merchant = arg.merchant || arg;
  const merchantConfig = getMerchantConfig(merchant);

  return merchantConfig && merchantConfig[configName] ? (merchantConfig[configName]: any) : null;
}
